var _rect, _rect2, _rect3, _circle, _rect4, _rect5, _rect6, _path, _rect7, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExercise1BluePerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 132,
    height: 174,
    viewBox: "0 0 132 174",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 127.837,
    y: 95.6986,
    width: 31.7085,
    height: 49.0196,
    rx: 15,
    transform: "rotate(153.861 127.837 95.6986)",
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 31.7085,
    height: 49.0196,
    rx: 15,
    transform: "matrix(0.897731 0.440543 0.440543 -0.897731 5.28418 95.0887)",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 31.2275,
    y: 53.8101,
    width: 72.8636,
    height: 99.9273,
    rx: 10,
    fill: "#889BD3"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 66.0592,
    cy: 30.8277,
    r: 30.8277,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 120.699,
    y: 115.598,
    width: 31.7085,
    height: 79.8658,
    rx: 15,
    transform: "rotate(69.8544 120.699 115.598)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 125.58,
    y: 79.7678,
    width: 31.7085,
    height: 53.6229,
    rx: 15,
    transform: "rotate(106.027 125.58 79.7678)",
    fill: "white"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    width: 31.7085,
    height: 53.6229,
    rx: 15,
    transform: "matrix(0.276097 0.96113 0.96113 -0.276097 5.28418 79.9874)",
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M72.5869 133.253L83.5076 163.021L70.7233 167.711C62.9459 170.564 54.328 166.572 51.4749 158.795L50.8865 157.191C48.0333 149.414 52.0252 140.796 59.8026 137.943L72.5869 133.253Z",
    fill: "#889BD3"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    width: 31.7085,
    height: 79.8658,
    rx: 15,
    transform: "matrix(-0.344407 0.93882 0.93882 0.344407 10.9209 116.265)",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.0342 133.919L48.1135 163.688L60.8978 168.378C68.6752 171.231 77.293 167.239 80.1462 159.462L80.7346 157.858C83.5878 150.08 79.5959 141.463 71.8184 138.609L59.0342 133.919Z",
    fill: "#889BD3"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M72.2246 28.1859C73.9862 29.3603 78.9186 31.0044 84.5557 28.1859",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M59.8936 42.2788C61.6551 43.4532 66.5876 45.0973 72.2246 42.2788",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5625 28.1859C49.3241 29.3603 54.2565 31.0044 59.8936 28.1859",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExercise1BluePerson);
export default __webpack_public_path__ + "static/media/exercise1-blue-person.d940f23c7afafd5d58c7b4b8aa30ce02.svg";
export { ForwardRef as ReactComponent };